<template>
  <v-app>
    <v-app-bar
        app
        dark
    >
      <div class="d-flex align-center">
        <v-img
            alt="Adosia Logo"
            class="shrink ma-2"
            contain
            :src="require('./assets/logo.png')"
            transition="scale-transition"
            width="196"
        />
      </div>

      <v-spacer></v-spacer>

      <!--      <v-btn
              href="https://github.com/adosia"
              target="_blank"
              text
            >
              <span class="mr-2">Latest Release</span>
              <v-icon>mdi-open-in-new</v-icon>
            </v-btn>-->
    </v-app-bar>

    <v-main>
      <AboutDrop :remaining="remaining"></AboutDrop>
      <v-container>
        <template v-if="status === 'init'">
          <v-row>
            <v-col cols="12" md="8">
              <h1 class="display-1">Preparing for launch...</h1>
              <template v-if="!pubsale && pubsale_start != null">
                <p class="body-1">Sales have not begun yet.</p>
                <v-alert type="info" border="left">Sales begin in
                  <Countdown :timestamp="pubsale_start"
                             @countdownComplete="getStatus"></Countdown>
                </v-alert>
              </template>
            </v-col>
          </v-row>
        </template>
        <template v-if="status === 'loading'">
          <v-progress-linear indeterminate height="30">
            <strong>Loading Cardano Light Wallets</strong>
          </v-progress-linear>
        </template>
        <template v-if="status === 'notfound'">
          <v-alert color="red" border="left" type="error">
            Sorry, no Cardano Light Wallets were detected on your system! Please try again using a browser with a
            Cardano
            wallet extension installed!
          </v-alert>
        </template>
        <template v-if="status === 'found'">
          <v-row>
            <v-col cols="12" md="6" class="text-center">
              <h2 class="display-1 mb-4">Get Started: Connect Your Wallet</h2>
              <v-btn v-for="wallet in wallets" :key="wallet.name" outlined x-large @click="connect(wallet)"
                     class="ma-2 text-start justify-start" :loading="wallet.loading" :disabled="wallet.loading">
                <v-img max-height="24" max-width="24" :src="wallet.icon" contain class="me-4"></v-img>
                {{ wallet.name }}
              </v-btn>
            </v-col>
          </v-row>
        </template>
        <template v-if="status === 'connected'">
          <v-row>
            <v-col cols="12" md="6">
              <h2 class="display-1 mb-4 d-flex flex-column flex-md-row align-center text-capitalize">
                <span class="d-flex flex-row flex-nowrap mb-2">
                  <v-img max-height="32" max-width="32" :src="activeWallet.icon" contain class="me-4"
                         :alt="wallet.name"></v-img>
                  {{ activeWallet.name.replace(' Wallet', '') }} Connected
                </span>
                <v-btn @click="changeWallet" :disabled="queueing" class="mx-4 d-block d-md-inline-block">Change Wallet
                </v-btn>
              </h2>
              <v-progress-linear indeterminate v-if="loadingBalance"></v-progress-linear>
              <h3 class="subtitle-1 mb-4 d-flex flex-column flex-md-row" v-if="!loadingBalance">
                Balance:
                <v-chip label color="primary" class="mx-2 mb-2">{{ walletBalance.ada }} &#8371;</v-chip>
                <v-chip label color="secondary" class="mx-2 mb-2">{{ walletBalance.adosia }} ADO</v-chip>
                <v-chip label color="purple" class="mx-2 mb-2">{{ walletBalance.spacecoins }} spacecoins</v-chip>
                <v-btn @click="checkBalance" :disabled="queueing" class="mx-4" small>Recheck Balance</v-btn>
              </h3>
              <v-alert v-if="!canBuy() && !loadingBalance" border="left" type="error" color="red">
                Sorry, your wallet balance is insufficient to purchase! Please connect with a
                different wallet.
              </v-alert>
              <v-form v-if="canBuy() && !loadingBalance && !queueing" v-model="transactionValid" ref="form">
                <label class="d-block mb-2">How would you like to pay?</label>
                <v-btn-toggle v-model="transaction.currency" mandatory class="mb-4" color="success" dark>
                  <v-btn value="lovelace" :disabled="!canAfford('lovelace')">ADA</v-btn>
                  <v-btn value="adosia" :disabled="!canAfford('adosia')">ADA + ADO</v-btn>
                  <v-btn value="spacecoins" :disabled="!canAfford('spacecoins')">ADA + spacecoins</v-btn>
                </v-btn-toggle>
                <label class="d-block mb-2">How many would you like to purchase?</label>
                <v-slider v-model="transaction.quantity" min="1" thumb-size="24"
                          :max="canAfford(transaction.currency)" thumb-label="always" class="mt-6"></v-slider>
                <label>Total Price</label>
                <v-row>
                  <v-col cols="6">
                    <v-text-field label="ADA" suffix="₳" :value="total('lovelace')" readonly></v-text-field>
                  </v-col>
                  <v-col v-if="transaction.currency === 'adosia'">
                    <v-text-field label="Adosia" suffix="ADO" :value="total('adosia')" readonly></v-text-field>
                  </v-col>
                  <v-col v-if="transaction.currency === 'spacecoins'">
                    <v-text-field label="spacecoins" suffix="spacecoins" :value="total('spacecoins')"
                                  readonly></v-text-field>
                  </v-col>
                </v-row>
                <v-btn :disabled="!transactionValid" :loading="queueing" color="primary" class="mb-4" @click="purchase">
                  Purchase
                </v-btn>
              </v-form>
              <template v-if="queueing">
                <v-progress-linear indeterminate height="12" class="my-4"></v-progress-linear>
                <template v-if="queue.status === 'WAITING'">
                  <h3 class="subtitle-1">Attempting to locate your rocket(s). Please stand by for launch...</h3>
                  <h4 class="subtitle-2" v-if="queue.position != null">You are currently at position
                    #{{ queue.position }} in the queue. There are {{ queue.ahead }} reservations ahead of you.</h4>
                </template>
                <template v-if="queue.status === 'PENDING'">
                  <h3 class="subtitle-1">All systems go. We are prepared for launch!</h3>
                  <h4 class="subtitle-2" v-if="queue.minting">Preparing your transaction now... Please sign the
                    transaction in your wallet to continue!</h4>
                </template>
                <template v-if="queue.status === 'SUBMITTED'">
                  <h3 class="subtitle-1">Your transaction has been submitted to the blockchain!</h3>
                  <h4 class="subtitle-2" v-if="txid">Transaction ID: {{ txid }}</h4>
                </template>
                <template v-if="sessionExpires != null">
                  <p class="body-1">
                    Your launch window closes in
                    <Countdown :timestamp="sessionExpires"></Countdown>
                  </p>
                </template>
              </template>
            </v-col>
          </v-row>
        </template>
      </v-container>
    </v-main>
    <v-footer dark>
      <v-container class="text-center justify-center">
        <p>Copyright &copy; 2022, Adosia LLC. All rights reserved.</p>
        <v-img :src="require('./assets/PoweredBuffyWhite.svg')" contain width="256" class="mx-auto"></v-img>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import * as CSL from './lib/CardanoSerializationLib';
import {Buffer} from 'buffer';
import AboutDrop from "@/components/About";
import Countdown from "@/components/Countdown";
import axios from "axios";

const protocolParameters = {
  linearFee: {
    minFeeA: "44",
    minFeeB: "155381",
  },
  minUtxo: "1000000",
  poolDeposit: "500000000",
  keyDeposit: "2000000",
  maxValSize: 5000,
  maxTxSize: 16384,
  costPerWord: "4310"
};

export default {
  name: 'App',

  components: {
    AboutDrop,
    Countdown
  },

  data: () => ({
    status: 'init',
    loop: null,
    retries: 10,
    cardano: false,
    wallets: [],
    wallet: null,
    activeWallet: false,
    transaction: {
      currency: false,
      quantity: 1,
      nonce: null
    },
    transactionValid: false,
    SupportedWallets: [
      'nami',
      'eternl',
      'flint',
      'typhoncip30',
      'gerowallet',
      'yoroi',
      'LodeWallet',
      'nufi'
    ],
    spacecoins: 'd894897411707efa755a76deb66d26dfd50593f2e70863e1661e98a0',
    adosia: '5ad8deb64bfec21ad2d96e1270b5873d0c4d0f231b928b4c39eb2435',
    loadingBalance: false,
    walletBalance: {
      ada: 0,
      adosia: 0,
      spacecoins: 0
    },
    queueing: false,
    stakekey: false,
    queue: {
      show: false,
      nonce: null,
      status: 'WAITING',
      position: null,
      ahead: null,
      minting: false
    },
    mintDetails: null,
    pollingSession: false,
    sessionExpires: null,
    txid: null,
    pollingStatus: false,
    pubsale: false,
    pubsale_start: null,
    maxQuantity: 8,
    remaining: 5000
  }),
  methods: {
    /** Utility Functions **/
    toUint8Array(hexString) {
      return Uint8Array.from(Buffer.from(hexString, 'hex'));
    },
    fromHex(string) {
      return Buffer.from(string, 'hex');
    },
    toHex(bytes) {
      return Buffer.from(bytes).toString('hex');
    },
    toAscii(bytes) {
      return Buffer.from(bytes).toString('ascii');
    },
    fromAscii(string) {
      return Buffer.from(string, 'ascii');
    },
    toAda(lovelace) {
      return lovelace / 1000000;
    },
    toLovelace(ada) {
      return ada * 1000000;
    },
    canBuy() {
      return Math.max(this.canAfford('lovelace'), this.canAfford('adosia'), this.canAfford('spacecoins'));
    },
    canAfford(currency) {
      if (currency === 'lovelace') {
        return Math.min(Math.floor(this.walletBalance.ada / 100), this.maxQuantity);
      }

      const ada_qty = Math.floor(this.walletBalance.ada / 50);

      if (!ada_qty) {
        return ada_qty;
      }

      if (currency === 'adosia') {
        const adosia_qty = Math.floor(this.walletBalance.adosia / 5000);
        return Math.min(Math.min(adosia_qty, ada_qty), this.maxQuantity);
      }

      if (currency === 'spacecoins') {
        const spacecoins_qty = Math.floor(this.walletBalance.spacecoins / 5000);
        return Math.min(Math.min(spacecoins_qty, ada_qty), this.maxQuantity);
      }
    },
    total(currency) {
      if (currency === 'lovelace') {
        if (this.transaction.currency === 'lovelace') {
          return this.transaction.quantity * 100;
        } else {
          return this.transaction.quantity * 50;
        }
      }

      return this.transaction.quantity * 5000;
    },
    async doError(message) {
      await this.$swal.fire({
        icon: 'error',
        html: `<span class="text-danger">${message}</span>`,
        showConfirmButton: true,
        confirmButtonText: 'Okay',
        allowOutsideClick: false
      });
    },
    async doSuccess(message) {
      await this.$swal.fire({
        icon: 'success',
        html: `<span class="text-success">${message}</span>`,
        showConfirmButton: true,
        confirmButtonText: 'Okay',
        allowOutsideClick: false
      })
    },
    /** End Utility Functions **/
    async getStatus() {
      try {
        const response = await axios.get('https://adosia.buffybot.io/api/v1/status/');
        this.remaining = response.data.remaining;
        this.maxQuantity = Math.min(this.maxQuantity, this.remaining);
        this.pubsale = response.data.public;
        this.pubsale_start = new Date(response.data.public_start);

        if (this.pubsale && this.status === 'init') {
          this.status = 'loading';
          this.checkForCardano();
        }

        if (this.remaining <= 0) {
          clearInterval(this.pollingStatus);
        }
      } catch (e) {
        console.error("Error fetching drop status!", e);
        clearInterval(this.pollingStatus);
        await this.doError("Encountered an issue attempting to check the drop status!");
      }
    },
    checkStatus() {
      this.getStatus();

      if (this.pubsale) {
        if (this.pollingStatus === null) {
          this.polling = setInterval(() => {
            this.getStatus();
          }, 30000);
        }
      }
    },
    async connect(wallet) {
      wallet.loading = true;
      try {
        this.activeWallet = wallet;
        this.wallet = await wallet.enable();
        this.status = 'connected';
        this.checkBalance();
      } catch (e) {
        console.error(e);
      }
      wallet.loading = false;
    },
    changeWallet() {
      this.activeWallet = false;
      this.wallet = null;
      this.status = 'found';
      this.walletBalance = {
        ada: 0,
        adosia: 0,
        spacecoins: 0
      };
      this.clearSession();
    },
    async checkBalance() {
      this.loadingBalance = true;
      const balance = CSL.Value.from_hex(await this.wallet.getBalance());
      this.walletBalance.ada = this.toAda(balance.coin().to_str());

      if (balance.multiasset() === undefined) {
        this.walletBalance.adosia = 0;
        this.walletBalance.spacecoins = 0;
      } else {
        const adosia_policy = CSL.ScriptHash.from_bytes(this.fromHex(this.adosia));
        const adosia_asset = CSL.AssetName.new(this.fromHex('61646f736961'));
        const adosia_balance = balance.multiasset().get_asset(adosia_policy, adosia_asset).to_str();
        this.walletBalance.adosia = this.toAda(adosia_balance);
        const spacecoins_policy = CSL.ScriptHash.from_bytes(this.fromHex(this.spacecoins));
        const spacecoins_asset = CSL.AssetName.new(this.fromHex('7370616365636f696e73'));
        this.walletBalance.spacecoins = balance.multiasset().get_asset(spacecoins_policy, spacecoins_asset).to_str();
      }
      this.loadingBalance = false;
    },
    checkForCardano() {
      let loop = setInterval(() => {
        if (this.retries <= 0) {
          if (!this.cardano) {
            this.status = 'notfound';
          } else {
            this.status = 'found';
          }
          clearInterval(loop);
          return;
        }

        if (window.cardano !== undefined) {
          this.cardano = window.cardano;
          this.checkWallets();
        }

        this.retries--;
      }, 200);
    },
    checkWallets() {
      if (this.cardano === false) {
        return;
      }

      this.SupportedWallets.forEach((name) => {
        if (this.cardano[name] === undefined) {
          return;
        }

        const wallet = this.cardano[name];
        if (!this.wallets.includes(wallet)) {
          this.wallets.push(wallet);
        }
      });
    },
    async purchase() {
      this.queueing = true;
      const token = await window.grecaptcha.execute('6LfOjB8bAAAAAB6ZHRG27FeZBmjwvrv_pbNX-8qZ', {
        action: 'EnterQueue'
      });

      const payload = {
        token: token,
        stakekey: this.stakekey,
        drop_id: 1,
        currency: this.transaction.currency,
        quantity: this.transaction.quantity
      };

      try {
        const response = await axios.post('https://adosia.buffybot.io/api/v1/validate/', payload);
        this.queue.nonce = response.data.nonce;
        this.queue.status = response.data.status;

        this.pollingSession = setInterval(this.checkSession, 15000);
        this.checkSession();
      } catch (err) {
        await this.doError("Oops, we've encountered an issue on the server side! Please try again later!");
        this.queueing = false;
      }
    },
    makeTransaction() {
      const txBuilderConfig = CSL.TransactionBuilderConfigBuilder.new()
          .fee_algo(
              CSL.LinearFee.new(
                  CSL.BigNum.from_str(protocolParameters.linearFee.minFeeA.toString()),
                  CSL.BigNum.from_str(protocolParameters.linearFee.minFeeB.toString())
              )
          )
          .coins_per_utxo_byte(CSL.BigNum.from_str(protocolParameters.costPerWord.toString()))
          .pool_deposit(CSL.BigNum.from_str(protocolParameters.poolDeposit.toString()))
          .key_deposit(CSL.BigNum.from_str(protocolParameters.keyDeposit.toString()))
          .max_value_size(protocolParameters.maxValSize)
          .max_tx_size(protocolParameters.maxTxSize)
          .ex_unit_prices(CSL.ExUnitPrices.new(
              CSL.UnitInterval.new(
                  CSL.BigNum.from_str('1'),
                  CSL.BigNum.from_str('1')
              ),
              CSL.UnitInterval.new(
                  CSL.BigNum.from_str('1'),
                  CSL.BigNum.from_str('1')
              )
          ))
          .build();

      return CSL.TransactionBuilder.new(
          txBuilderConfig
      );
    },
    async getChangeAddress() {
      const usedAddresses = await this.wallet.getUsedAddresses();
      const addressHex = this.fromHex(usedAddresses[0]);
      if (!addressHex) {
        return;
      }
      return CSL.Address.from_bytes(addressHex);
    },
    async buildTransaction() {
      this.queue.minting = true;
      const paymentAddress = await this.getChangeAddress();

      if (!paymentAddress) {
        console.error("Could not find the change address?");
        this.queue.minting = false;
        return;
      }

      const mintAssets = [];
      const tokenMetadata = this.mintDetails.meta;
      const policy_hash = this.mintDetails.policy.policyHash;
      const policy_id = this.mintDetails.policy.policyId;

      this.mintDetails.tokens.forEach((token) => {
        mintAssets.push({
          assetName: token,
          quantity: 1,
          policyId: policy_id,
          policyScript: policy_hash
        });
      });

      let payment = {
        address: this.mintDetails.payTo,
        amount: this.mintDetails.payValue.lovelace
      };

      if (this.mintDetails.payValue.adosia) {
        payment.adosia = this.mintDetails.payValue.adosia;
      }

      if (this.mintDetails.payValue.spacecoins) {
        payment.spacecoins = this.mintDetails.payValue.spacecoins;
      }

      const recipients = [
        payment,
        {
          address: paymentAddress.to_bech32(),
          amount: 0,
          mintedAssets: mintAssets
        }
      ];

      const inputs = CSL.TransactionUnspentOutputs.new();
      (await this.wallet.getUtxos()).map((utxo) => inputs.add(CSL.TransactionUnspentOutput.from_bytes(this.fromHex(utxo))));

      const txBuilder = this.makeTransaction();

      let minting = 0;
      let MintAssets = [];
      let MintingPolicies = [];

      recipients.forEach((recipient) => {
        let lovelace = Math.floor((recipient.amount || 0) * 1000000).toString();

        let ReceiveAddress = CSL.Address.from_bech32(recipient.address);
        let output;

        if (recipient.mintedAssets !== undefined && recipient.mintedAssets.length) {
          recipient.mintedAssets.forEach((asset) => {
            minting++;

            if (!MintingPolicies.includes(asset.policyScript)) {
              MintingPolicies.push(asset.policyScript);
            }

            MintAssets.push(asset);
          });
          return;
        }

        if (recipient.adosia || recipient.spacecoins) {
          const lovelace_val = CSL.BigNum.from_str(lovelace);
          const multiasset = CSL.MultiAsset.new();
          let scriptHash, asset, value;
          if (recipient.adosia) {
            scriptHash = CSL.ScriptHash.from_hex(this.adosia);
            asset = CSL.AssetName.new(this.fromHex('61646f736961'));
            value = CSL.BigNum.from_str((recipient.adosia * 1000000).toString());
          }
          if (recipient.spacecoins) {
            scriptHash = CSL.ScriptHash.from_hex(this.spacecoins);
            asset = CSL.AssetName.new(this.fromHex('7370616365636f696e73'));
            value = CSL.BigNum.from_str(recipient.spacecoins.toString());
          }
          multiasset.set_asset(scriptHash, asset, value);

          output = CSL.TransactionOutputBuilder.new()
              .with_address(ReceiveAddress).next()
              .with_coin_and_asset(
                  lovelace_val,
                  multiasset
              ).build();
        } else {
          output = CSL.TransactionOutputBuilder.new()
              .with_address(ReceiveAddress).next()
              .with_coin(CSL.BigNum.from_str(lovelace.toString()))
              .build();
        }

        try {
          txBuilder.add_output(output);
        } catch (err) {
          console.error("Error attempting to add an output", err);
        }
      });

      const NativeScripts = CSL.NativeScripts.new();

      if (minting) {
        let assetsDict = {};

        MintingPolicies.forEach((scriptHash) => {
          NativeScripts.add(CSL.NativeScript.from_bytes(this.fromHex(scriptHash)));
        });

        mintAssets.forEach((entry) => {
          if (assetsDict[entry.assetName] === undefined) {
            assetsDict[entry.assetName] = {
              quantity: 0,
              policyId: entry.policyId,
              scriptHash: entry.policyScript
            };
          }
          assetsDict[entry.assetName].quantity = assetsDict[entry.assetName].quantity + parseInt(entry.quantity);
        });


        Object.entries(assetsDict).map(([name, asset]) => {
          try {

            let assetQty;


            if (asset.quantity < 0) {
              assetQty = CSL.Int.new_negative(CSL.BigNum.from_str((asset.quantity * -1).toString()));
            } else {
              assetQty = CSL.Int.new(CSL.BigNum.from_str(asset.quantity.toString()));
            }

            txBuilder.add_mint_asset(
                CSL.NativeScript.from_bytes(this.fromHex(asset.scriptHash)),
                CSL.AssetName.new(Buffer.from(name)),
                assetQty
            );
          } catch (e) {
            this.doError("Error attempting to add a new minted asset!");
            console.error("Error attempting to add a minted asset!", e, asset, name);
          }
        });

        Object.entries(tokenMetadata).map(([MetadataLabel, Metadata]) => {
          txBuilder.add_json_metadatum(
              CSL.BigNum.from_str(MetadataLabel),
              JSON.stringify(Metadata)
          );
        });
      }

      txBuilder.set_ttl(parseInt(this.mintDetails.ttl));

      try {
        txBuilder.add_inputs_from(inputs, CSL.CoinSelectionStrategyCIP2.LargestFirstMultiAsset);
        txBuilder.add_change_if_needed(paymentAddress);
      } catch (e) {
        this.doError("Not enough inputs to build the transaction!");
        this.queue.minting = false;
        console.error(e);
        return;
      }

      let txBuilt;
      try {
        txBuilt = await txBuilder.build();
      } catch (e) {
        this.doError("Could not build the transaction!");
        this.queue.minting = false;
        console.error(e);
        return;
      }

      const auxDataHash = CSL.AuxiliaryDataHash.from_bytes(this.fromHex(this.mintDetails.metaDetails.hash));
      txBuilt.set_auxiliary_data_hash(auxDataHash);

      const witnessSet = CSL.TransactionWitnessSet.new();
      witnessSet.set_native_scripts(NativeScripts);

      const tx = CSL.Transaction.new(
          txBuilt,
          witnessSet
      );

      try {
        const txHex = this.toHex(tx.to_bytes());

        const txVkeyWitnesses = await this.wallet.signTx(txHex, true);
        return {
          tx: txHex,
          witness: txVkeyWitnesses
        }
      } catch (e) {
        this.doError("You declined to sign the transaction!");
        console.error(e);
        this.queue.minting = false;
        await this.cancelQueue();
      }

    },
    async checkSession() {
      const nonce = this.queue.nonce;

      try {
        const response = await axios.post('https://adosia.buffybot.io/api/v1/poll/', {
          nonce: nonce
        });

        this.queue.status = response.data.status;
        this.queue.position = response.data.qpos;
        this.queue.ahead = response.data.ahead ?? 0;

        if (response.data.status === 'PENDING') {
          this.mintDetails = response.data.details;
          if (this.sessionExpires === null) {
            this.sessionExpires = new Date(this.mintDetails.sessionExpires);
          }
          if (!this.queue.minting) {
            const signed = await this.buildTransaction();
            await this.submitTxn(signed);
          }
        }

        if (response.data.status === 'EXPIRED') {
          this.clearSession();
          await this.doError("Sorry, your session has expired!");
        }

        if (response.data.status === 'SUBMITTED') {
          this.txid = response.data.txHash;
        }

        if (response.data.status === 'COMPLETE') {
          await this.doSuccess('Transaction complete!');
          this.clearSession();
          await this.checkBalance();
        }

      } catch (err) {
        console.error(err);
      }
    },
    clearSession() {

      this.transaction = {
        currency: false,
        quantity: 1,
        nonce: null
      };

      this.queue = {
        show: false,
        nonce: null,
        status: 'WAITING',
        position: null,
        ahead: null,
        minting: false,
      };

      this.txid = null;
      this.mintDetails = null;
      this.sessionExpires = null;
      this.queueing = false;
      clearInterval(this.pollingSession);
    },
    async cancelQueue() {
      try {
        await axios.post('https://adosia.buffybot.io/api/v1/cancel/', {
          nonce: this.queue.nonce
        });
        this.clearSession();
      } catch (err) {
        console.info("Error cancelling session!");
        console.error(err);
      }
    },
    async submitTxn(signed) {
      const session_nonce = this.queue.nonce;

      if (!signed || !session_nonce) {
        this.queue.minting = false;
        return;
      }

      signed.nonce = session_nonce;

      try {
        await axios.post('https://adosia.buffybot.io/api/v1/submit/', signed);
        this.queue.minting = false;
      } catch (err) {
        console.error(err);
        this.doError("Error attempting to submit the transaction!");
        this.queue.minting = false;
      }
    }
  },
  async mounted() {
    this.checkStatus();
  }
};
</script>

<style>
.swal2-container {
  font-family: 'Roboto', sans-serif;
}

.grecaptcha-badge {
  z-index: 999;
}
</style>
